<!--
  * @name: abin
  * @description: 跳转下载中心弹窗
  * @date:2022-5-19
-->
<template>
  <lsDownLoad v-bind="$attrs" :goToUrl="goToUrl" v-on="$listeners" ref="downLoad"></lsDownLoad>
</template>

<script>
export default {
  name: "ExportModal",
  inheritAttrs: false,
  data () {
    return {
      goToUrl: process.env.VUE_APP_API_SCM_URL + '/#/download-page/download-page'
    }
  },
  methods: {
    openModal (parmas) {
      this.$refs.downLoad.openModal(parmas)
    }
  }
}
</script>

<style scoped>

</style>
